<div
  class="input-field"
  [ngClass]="{
    'has-value': !!fieldControl?.value,
    condensed: condensed,
    'has-placeholder': !!placeholder
  }"
>
  <label
    class="input-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    [attr.type]="type"
  >
    {{ label }}
  </label>

  <div class="input-wrapper" [ngClass]="{ 'has-left-icon': !!leftIcon }">
    <app-icon *ngIf="leftIcon" class="icon" [icon]="leftIcon"> </app-icon>

    <input
      class="input"
      tabindex="0"
      [focusable]="focusableTrigger$"
      [attr.type]="type"
      [attr.id]="fieldId"
      [attr.placeholder]="placeholder"
      [attr.maxlength]="maxlength <= 0 ? null : maxlength"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [autoComplete]="options?.autoComplete"
      [formControl]="fieldControl"
      [attr.data-e2e-id]="e2eId"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (onBlur)="onBlur.emit(fieldControl.value)"
      (onFocus)="onFocus.emit(fieldControl.value)"
      (keyup)="onInputKeyup.emit($event)"
      (onAutoCompleteFetchStart)="onAutoCompleteFetchStart.emit()"
      (onAutoCompleteFetchEnd)="onAutoCompleteFetchEnd.emit($event)"
      (onAutoCompleteSet)="onAutoCompleteSet.emit($event)"
      (onAutoCompleteHide)="onAutoCompleteHide.emit()"
      (onAutoCompleteDestroy)="onAutoCompleteDestroy.emit()"
    />

    <app-icon
      *ngIf="rightIcon"
      class="icon right-icon"
      [icon]="rightIcon"
      (click)="onRightActionClick.emit()"
    >
    </app-icon>

    <app-error-message
      [fieldControl]="fieldControl"
      [errorMessage]="errorMessage"
    >
    </app-error-message>
  </div>
</div>

<p *ngIf="description" class="description">
  {{ description }}
</p>
